import React from 'react';
//import './YourStyleSheet.css'; // Replace with your actual stylesheet path

const AnnualReports = () => {
    return (
<div className="container">
    <p></p>
    <div className="section-title">
        <small>ANNUAL REPORTS</small>
        <h3 className="h3-purple">Annual Reports</h3>
    </div>


    <div className="paul-cards-container">
                

        <div className="paul-card">
                        <div className="paul-card-head-top-part-of-card">
                        <br></br>
                            <span className="price">2014</span>
                        </div>

                        <ul className="list-group list-group-flush">
                            <div className="paul-list-group-item">Annual Report</div>
                        </ul>
                        
                        <div className="paul-card-padding-around-button">
                            <a href="https://public-dfa-forms.s3.eu-west-2.amazonaws.com/accounts_2014.pdf" className="btn btn-primary btn-lg btn-block">DOWNLOAD</a>
                        </div>
        </div>


        <div className="paul-card">
                        <div className="paul-card-head-top-part-of-card">  
                        <br></br>  
            
                            <span className="price">2015</span>
                        </div>

                        <ul className="list-group list-group-flush">
                            <div className="paul-list-group-item">Annual Report</div>
                            
                        </ul>
                        
                        <div className="paul-card-padding-around-button">
                            <a href="https://public-dfa-forms.s3.eu-west-2.amazonaws.com/accounts_2015.pdf" className="btn btn-primary btn-lg btn-block">DOWNLOAD</a>
                        </div>
        </div>

        <div className="paul-card">

                <div className="paul-card-head-top-part-of-card">  
                <br></br>
                        
                    <span className="price">2016</span>
                </div>

                <ul className="list-group list-group-flush">
                    <div className="paul-list-group-item">Annual Report</div>
                </ul>
                
                <div className="paul-card-padding-around-button">
                    <a href="https://public-dfa-forms.s3.eu-west-2.amazonaws.com/accounts_2016.pdf" className="btn btn-primary btn-lg btn-block">DOWNLOAD</a>
                </div>
        </div>

        <div className="paul-card">
        <div className="paul-card-head-top-part-of-card">  
        <br></br>    
            <span className="price">2017</span>
                        
        </div>

                <ul className="list-group list-group-flush">
                    <div className="paul-list-group-item">Annual Report</div>
                   
                </ul>
                
                <div className="paul-card-padding-around-button">
                    <a href="https://public-dfa-forms.s3.eu-west-2.amazonaws.com/accounts_2017.pdf" className="btn btn-primary btn-lg btn-block">DOWNLOAD</a>
                </div>
        </div>

        <div className="paul-card">
                        <div className="paul-card-head-top-part-of-card">
                        <br></br>
                            <span className="price">2018</span>
                        </div>

                        <ul className="list-group list-group-flush">
                            <div className="paul-list-group-item">Annual Report</div>
                            
                        </ul>
                        
                        <div className="paul-card-padding-around-button">
                            <a href="https://public-dfa-forms.s3.eu-west-2.amazonaws.com/DFA_Annual_Accounts_2018_finalised.pdf" className="btn btn-primary btn-lg btn-block">DOWNLOAD</a>
                        </div>
        </div>


        <div className="paul-card">
                        <div className="paul-card-head-top-part-of-card">  
                        <br></br>   
            
                            <span className="price">2019</span>
                        </div>

                        <ul className="list-group list-group-flush">
                            <div className="paul-list-group-item">Annual Report</div>
                           
                        </ul>
                        
                        <div className="paul-card-padding-around-button">
                            <a href="https://public-dfa-forms.s3.eu-west-2.amazonaws.com/DFA_Annual_Accounts_2019_filed_with_the_Charity_Commission.pdf" className="btn btn-primary btn-lg btn-block">DOWNLOAD</a>
                        </div>
        </div>


        <div className="paul-card">

                <div className="paul-card-head-top-part-of-card">  
                   <br></br>
                        
                    <span className="price">2020</span>
                </div>

                <ul className="list-group list-group-flush">
                    <div className="paul-list-group-item">Annual Report</div>
                   
                </ul>
                
                <div className="paul-card-padding-around-button">
                    <a href="https://public-dfa-forms.s3.eu-west-2.amazonaws.com/DFA_Annual_Accounts%202020_signed%20accountants.pdf" className="btn btn-primary btn-lg btn-block">DOWNLOAD</a>
                </div>
        </div>

        <div className="paul-card">
        <div className="paul-card-head-top-part-of-card">  
        <br></br>    
            <span className="price">2021</span>
                        
        </div>

                <ul className="list-group list-group-flush">
                    <div className="paul-list-group-item">Annual Report</div>
                   
                </ul>
                
                <div className="paul-card-padding-around-button">
                    <a href="https://public-dfa-forms.s3.eu-west-2.amazonaws.com/DFA_Annual_Accounts_2021_final.pdf" className="btn btn-primary btn-lg btn-block">DOWNLOAD</a>
                </div>
        </div>

        <div className="paul-card">
                        <div className="paul-card-head-top-part-of-card">
                        <br></br>
                            <span className="price">2022</span>
                        </div>

                        <ul className="list-group list-group-flush">
                            <div className="paul-list-group-item">Annual Report</div>
                           
                        </ul>
                        
                        <div className="paul-card-padding-around-button">
                            <a href="https://public-dfa-forms.s3.eu-west-2.amazonaws.com/DFA_Annual_Accounts_2022_Final_signed_AK.pdf" className="btn btn-primary btn-lg btn-block">DOWNLOAD</a>
                        </div>
        </div>


        <div className="paul-card">
                        <div className="paul-card-head-top-part-of-card">  
                        <br></br> 
            
                            <span className="price">2023</span>
                        </div>

                        <ul className="list-group list-group-flush">
                            <div className="paul-list-group-item">Annual Report</div>
                            
                        </ul>
                        
                        <div className="paul-card-padding-around-button">
                            <a href="https://public-dfa-forms.s3.eu-west-2.amazonaws.com/DFA+Annual+Accounts+2023+%2B+JK+review.pdf" className="btn btn-primary btn-lg btn-block">PENDING</a>
                        </div>
        </div>



        <div className="paul-card">
                        <div className="paul-card-head-top-part-of-card">  
                        <br></br> 
            
                            <span className="price">2024</span>
                        </div>

                        <ul className="list-group list-group-flush">
                            <div className="paul-list-group-item">Annual Report</div>
                            
                        </ul>
                        
                        <div className="paul-card-padding-around-button">
                            <a href="https://public-dfa-forms.s3.eu-west-2.amazonaws.com/DFA+Annual+Report+-+31st+December+2024.pdf" className="btn btn-primary btn-lg btn-block">PENDING</a>
                        </div>
        </div>


    </div>

           
</div>
);
};

export default AnnualReports;
